module.exports = __webpack_public_path__ + "img/tiktok.7ac935a7.svg";